import { useEffect, useCallback, useState, useRef } from 'react';
import { removeSessionItem, getSessionItem, setSessionItem } from '../utils/storage';
import { LOCAL_STORAGE_KEY } from '../constants/storage';
export default function useUserAttribute(getUserAttributes, setUserAttribute, attributeKey, cacheSeenInWindow = false) {
  const [attributeLoaded, setAttributeLoaded] = useState(false);
  const [hasAttribute, setHasAttribute] = useState(false);
  const hasSeenStorageKeyRef = useRef(null);
  const handleSetUserAttribute = useCallback((value = true) => {
    setUserAttribute(attributeKey, value).catch(error => {
      console.error('Unable to set user attribute', error);
    });
    setHasAttribute(value);
  }, [setUserAttribute, attributeKey]);
  useEffect(() => {
    getUserAttributes(attributeKey).then(attributeValue => {
      let hasAttr = !!(attributeKey && attributeValue === 'true');
      if (cacheSeenInWindow) {
        hasSeenStorageKeyRef.current = `${LOCAL_STORAGE_KEY}:${attributeKey}`;
        const hasSeenInWindow = !!getSessionItem(hasSeenStorageKeyRef.current);
        hasAttr = hasAttr || hasSeenInWindow;
        setSessionItem(hasSeenStorageKeyRef.current, true);
      }
      setHasAttribute(hasAttr);
      setAttributeLoaded(true);
    }).catch(console.error);
    if (cacheSeenInWindow) {
      const handleClearSession = () => {
        if (document.visibilityState === 'hidden' && hasSeenStorageKeyRef.current) {
          removeSessionItem(hasSeenStorageKeyRef.current);
        }
      };
      window.addEventListener('visibilitychange', handleClearSession);
      return () => window.removeEventListener('visibilitychange', handleClearSession);
    }
    return undefined;
  }, [getUserAttributes, attributeKey, cacheSeenInWindow]);
  return [attributeLoaded, hasAttribute, handleSetUserAttribute];
}